import React, { useState } from 'react';
import get from 'lodash/get';
import clsx from 'clsx';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import IconWithText from '../../../components/molecules/IconWithText';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Link from '../../../components/atoms/Link';
import RichText from '../../../components/atoms/RichText';
import Container from '../../../components/molecules/Container';
import { createPhoneLink } from '../../../../utils/utility';
import Typography from '../../../components/atoms/Typography';
import Grid from '../../../components/molecules/Grid';
import * as locators from './locators';
import useStyles from './style';
import Accordion from '../../../components/atoms/Accordion';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import { createDynamicLabels } from '../../../../../src/utils/analytics';
const BusinessFacility = props => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(1);
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const highlightsLabel = props && props.t && props.t('highlightsLabel');
  const personOfContactLabel =
    props && props.t && props.t('personOfContactLabel');
  const {
    contactPerson,
    description,
    emailId,
    heading,
    businessHighlights,
    phoneNumber,
    facilitiesTable,
  } = props.fields;

  const isContactInfoPresent = contactPerson || emailId || phoneNumber;

  if (
    !heading &&
    (!businessHighlights || businessHighlights.length === 0) &&
    !isContactInfoPresent &&
    !description &&
    !(facilitiesTable && facilitiesTable.value)
  ) {
    return null;
  }

  return (
    <Container className={classes.root} data-locator={locators.COMPONENT_NAME}>
      <Grid>
        <Accordion
          className={classes.accordion}
          tabIdentifier={0}
          expanded={expanded}
          handleChange={handleChange}
        >
          {heading && (
            <Typography component="h2" variant="h4">
              <Text field={heading} />
            </Typography>
          )}
          <React.Fragment>
            {contactPerson &&
              contactPerson.value &&
              personOfContactLabel &&
              isContactInfoPresent && (
                <Typography
                  variant="body2"
                  component="div"
                  className={classes.labelContact}
                >
                  {personOfContactLabel}
                </Typography>
              )}
            {isContactInfoPresent && (
              <div className={classes.contactInfo}>
                {contactPerson && contactPerson.value && (
                  <Typography
                    variant="body1Bold"
                    component="span"
                    className={classes.contactPerson}
                  >
                    <Text field={contactPerson} />
                  </Typography>
                )}
                {emailId && get(emailId, 'value.text', '') && (
                  <Link
                    data-id={get(
                      analyticsData,
                      'dataIds.pageBodyNavLinkClick',
                      ''
                    )}
                    data-link={createDynamicLabels([
                      getPageName(props),
                      getComponentName(props),
                      get(analyticsData, 'dataLinksText.contactByEmail'),
                    ])}
                    isCustom={true}
                    customHref={get(emailId, 'value.href', '')}
                    className={classes.email}
                  >
                    <Typography variant="body2" component="span">
                      <Text field={{ value: get(emailId, 'value.text', '') }} />
                    </Typography>
                  </Link>
                )}
                {phoneNumber && phoneNumber.value && (
                  <Link
                    data-id={get(analyticsData, 'dataIds.pageBodyNavLinkClick')}
                    data-link={createDynamicLabels([
                      getPageName(props),
                      getComponentName(props),
                      get(analyticsData, 'dataLinksText.contactByPhone'),
                    ])}
                    isCustom={true}
                    customHref={createPhoneLink(phoneNumber.value)}
                    className={clsx('no-flip', classes.email)}
                  >
                    <Typography variant="body2" component="span">
                      <Text field={phoneNumber} />
                    </Typography>
                  </Link>
                )}
              </div>
            )}
            {description && description.value && (
              <Typography
                variant="body1"
                component="p"
                className={classes.description}
              >
                <Text field={description} />
              </Typography>
            )}
            <Grid container className={classes.highlightSection}>
              {businessHighlights && businessHighlights.length > 0 && (
                <>
                  <Grid item xs={12} lg={3}>
                    <Typography
                      className={classes.highlightsLabel}
                      component="h5"
                      variant="h5Bold"
                    >
                      <Text field={{ value: highlightsLabel }} />
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={9}>
                    <Grid container className={classes.iconWrapper}>
                      {businessHighlights.slice(0, 6).map((iconItem, index) => {
                        return (
                          <Grid item xs={12} lg={4} direction="row" key={index}>
                            <IconWithText
                              iconImage={get(
                                iconItem,
                                'fields.highlightType.fields.icon',
                                ''
                              )}
                              iconWithCircle={false}
                              className={clsx(
                                classes.iconWithText,
                                'hightlight-icon'
                              )}
                              variant="square"
                            >
                              <Typography variant="body1" component="span">
                                <Text field={iconItem.fields.text} />
                              </Typography>
                            </IconWithText>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                </>
              )}
              <RichText
                className={classes.facilitiesTable}
                innerHTML={facilitiesTable}
              />
            </Grid>
          </React.Fragment>
        </Accordion>
      </Grid>
    </Container>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(BusinessFacility))
);
